//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export class GoogleTagManagerList
{
	public static searchResults: string = `Search Results`;
	public static productCard: string = `Product Card`;
	public static cartItems: string = `Cart Items`;
	public static featuredProducts: string = `Featured Products`;
	public static categoryAssociatedProducts: string = `Suggested Products`;
	public static brandAssociatedProducts: string = `Related Products`;
	public static brandPage: string = `Brand Page`;
	public static subbrandPage: string = `Subbrand Page`;
	public static categoryPage: string = `Category Page`;
	public static subcategoryPage: string = `Subcategory Page`;
	public static campaignPage: string = `Campaign Page`;
	public static cartPage: string = `Cart Page`;
	public static favouriteProducts: string = `Favourite Products`;
	public static cartRecommendedProducts: string = `Cart Recommended Products`;
	public static cartDrawerRecommendedProducts: string = `Cart Drawer Recommended Products`;
	public static homePageRecommendedProducts: string = `Home Page Recommended Products`;
	public static productPageRecommendedProducts: string = `Product Page Recommended Products`;
	public static productPageCrossSellRecommendedProducts: string = `Product Page Cross Sell Recommended Products`;
	public static productPageRecommendedFallbackBrandProducts: string = `Product Page Recommended Fallback Brand Products`;
	public static productPageRecommendedFallbackCategoryProducts: string = `Product Page Recommended Fallback Category Products`;
	public static homePage: string = `Home Page`;
	public static productPage: string = `Product Page`;
}
